/**
 * Vỏ ứng dụng: quản lý phiên làm việc và chọn giữa trang đăng nhập và khung trang.
 *
 * Ba tình huống:
 *   * chưa có token          → trang đăng nhập;
 *   * có token, chưa có hồ sơ → chờ, vì quyền quyết định cả điều hướng lẫn tuyến;
 *   * có hồ sơ               → khung trang, phạm vi địa bàn mặc định theo phân công.
 */
import { useCallback, useEffect, useState, type ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { BoDinhTuyen } from './dinh-tuyen/bo-dinh-tuyen';
import { datToken, hoSoHienTai, layToken, type HoSoNguoiDung } from './api/khach-api';
import { NhaCungCapPhien } from './trang-thai/ngu-canh-phien';
import { TrangDangNhap } from './trang/TrangDangNhap';
import { vi } from './ngon-ngu/vi';
import './mau-sac/bang-mau.css';

export function App(): ReactNode {
  const [hoSo, datHoSo] = useState<HoSoNguoiDung | null>(null);
  const [dangKiemTra, datDangKiemTra] = useState<boolean>(() => layToken() !== null);

  const nap = useCallback(() => {
    if (!layToken()) {
      datDangKiemTra(false);
      return;
    }
    datDangKiemTra(true);
    void hoSoHienTai()
      .then((p) => {
        if (p.success && p.data) datHoSo(p.data);
        else {
          // Token hết hạn hoặc bị thu hồi: xoá để người dùng đăng nhập lại.
          datToken(null);
          datHoSo(null);
        }
      })
      .catch(() => datHoSo(null))
      .finally(() => datDangKiemTra(false));
  }, []);

  useEffect(() => nap(), [nap]);

  const dangXuat = useCallback(() => {
    datToken(null);
    datHoSo(null);
  }, []);

  if (dangKiemTra) {
    return (
      <p role="status" data-vung="dang-kiem-tra-phien">
        {vi.dangNhap.dangKiemTraPhien}
      </p>
    );
  }

  if (!hoSo) return <TrangDangNhap onDangNhapXong={nap} />;

  return (
    <NhaCungCapPhien hoSo={hoSo} onCapNhatHoSo={datHoSo}>
      <BrowserRouter>
        <BoDinhTuyen hoTen={hoSo.hoTen} tenTinh={hoSo.tenTinh ?? undefined} onDangXuat={dangXuat} />
      </BrowserRouter>
    </NhaCungCapPhien>
  );
}
